import SubscriberDependentsTable from 'components/common/election/SubscriberDependentsTable';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useFullFormPageStore } from 'store/pages/quote/add-employees/full-form/pageStore';
import { useAddDependentModalStore } from 'store/modules/elections/dependents/addDependentModalStore';
import { DynamicFormModal } from '@insurancemenu/imenu-components-lib';
import { ADD_DEPENDENT_MODAL_TEST_ID, DEPENDENTS_TAB_TEST_ID } from '../../constants';

const DependentsTab: React.FC = observer(() => {
  const {
    electionsModule: { requiredSubInfo },
    isInitialDataLoading,
    electionsModule,
  } = useFullFormPageStore();

  const addDependentModalStore = useAddDependentModalStore({
    subscriberDelegate: electionsModule.subscribers[0]?.subscriberDelegate,
    formId: requiredSubInfo!.manageDependentFormId,
  });

  return (
    <div data-test-id={DEPENDENTS_TAB_TEST_ID}>
      <SubscriberDependentsTable
        isLoading={isInitialDataLoading}
        dependentDelegates={electionsModule.subscribers[0]?.subscriberDelegate?.subscriberDependentsDelegates}
        subscriberDelegate={electionsModule.subscribers[0]?.subscriberDelegate}
        formId={requiredSubInfo!.manageDependentFormId}
        onAddDependent={addDependentModalStore?.openAddDependentModal}
      />

      {addDependentModalStore && (
        <DynamicFormModal
          show={addDependentModalStore.showAddDependentModal}
          onClose={addDependentModalStore.closeAddDependentModal}
          formDelegate={addDependentModalStore.dynamicFormDelegate}
          modalMaxWidth="90rem"
          data-test-id={ADD_DEPENDENT_MODAL_TEST_ID}
          completeButtonText="Save"
        />
      )}
    </div>
  );
});

export default DependentsTab;
